import React, { useState } from 'react';
import { UserProfile } from '../../types';
import { Save, Users, UserPlus, RefreshCw } from 'lucide-react';
import { soundEffects } from '../../lib/soundEffects';

interface Props {
  currentUser: UserProfile;
  onUpdateProfile: (profile: Partial<UserProfile>) => void;
}

export const ContactsSettingsSection: React.FC<Props> = ({ currentUser, onUpdateProfile }) => {
  const [contacts, setContacts] = useState(currentUser.contactsSettings || {
    syncContacts: false,
  });

  const [isSaving, setIsSaving] = useState(false);
  const [savedSuccess, setSavedSuccess] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncedSuccess, setSyncedSuccess] = useState(false);

  const handleSave = async () => {
    soundEffects.playTap();
    setIsSaving(true);
    await onUpdateProfile({ contactsSettings: contacts });
    setIsSaving(false);
    setSavedSuccess(true);
    setTimeout(() => setSavedSuccess(false), 2000);
  };

  const handleSyncContacts = () => {
    soundEffects.playTap();
    setIsSyncing(true);
    setTimeout(() => {
      setIsSyncing(false);
      setSyncedSuccess(true);
      setTimeout(() => setSyncedSuccess(false), 2000);
    }, 2000);
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="bg-[#0e1422] rounded-3xl p-5 border border-slate-800/80 shadow-lg">
        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
          <Users className="w-5 h-5 text-emerald-400" />
          جهات الاتصال
        </h3>

        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-[#141c2a] rounded-xl border border-slate-800">
            <div>
              <div className="text-sm font-semibold text-slate-200">مزامنة جهات الاتصال</div>
              <div className="text-[10px] text-slate-400 mt-1 max-w-[200px]">السماح لتطبيق وتين بالوصول لجهات اتصالك لإيجاد أصدقائك بسهولة.</div>
            </div>
            <button
              onClick={() => setContacts({ ...contacts, syncContacts: !contacts.syncContacts })}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${contacts.syncContacts ? 'bg-emerald-500' : 'bg-slate-700'}`}
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${contacts.syncContacts ? 'translate-x-1' : '-translate-x-6'}`} />
            </button>
          </div>
          
          <button className="w-full mt-2 py-3 bg-[#141c2a] border border-slate-700/80 text-emerald-400 font-bold rounded-xl flex items-center justify-center gap-2 transition hover:bg-emerald-500/10 active:scale-95">
            <UserPlus className="w-4 h-4" />
            دعوة أصدقاء إلى وتين
          </button>
          
          <button onClick={handleSyncContacts} disabled={isSyncing} className={`w-full py-3 border border-slate-700/80 font-bold rounded-xl flex items-center justify-center gap-2 transition active:scale-95 ${syncedSuccess ? 'bg-emerald-500/10 text-emerald-400' : 'bg-[#141c2a] text-slate-300 hover:bg-slate-800 disabled:opacity-50'}`}>
            <RefreshCw className={`w-4 h-4 ${isSyncing ? 'animate-spin' : ''}`} />
            {isSyncing ? 'جاري المزامنة...' : syncedSuccess ? 'تمت المزامنة بنجاح' : 'إدارة جهات الاتصال المتزامنة'}
          </button>
        </div>

        <button disabled={isSaving} onClick={handleSave} className={`mt-4 w-full py-2.5 font-bold rounded-xl flex items-center justify-center gap-2 transition active:scale-95 ${savedSuccess ? 'bg-emerald-400 text-slate-900' : 'bg-emerald-500 hover:bg-emerald-400 text-slate-950 disabled:opacity-50'}`}>
          <Save className="w-4 h-4" />
          {isSaving ? 'جاري الحفظ...' : savedSuccess ? 'تم الحفظ' : 'حفظ إعدادات جهات الاتصال'}
        </button>
      </div>
    </div>
  );
};
